import { ApolloLink } from '@apollo/client';

const costMetrics: Record<string, unknown> = {};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const storeCost = (cost: unknown) => {
  if (!isRecord(cost)) return;
  Object.assign(costMetrics, cost);
};

const costReportingLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    storeCost(response?.extensions?.cost);

    return response;
  });
});

export default costReportingLink;

export const costReport = () => costMetrics;

export const resetCostReport = () => {
  for (const prop of Object.getOwnPropertyNames(costMetrics)) {
    delete costMetrics[prop];
  }
};

declare global {
  interface Window {
    INCLUDE_FIELD_COSTS?: boolean;
  }
}

export const includeFieldCost = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (window.INCLUDE_FIELD_COSTS) {
    return true;
  }

  const params = new URLSearchParams(window.location?.search ?? '');

  return params.get('graphql-cost-include-fields') === 'true';
};
